class Recaptcha {
  constructor(private readonly siteKey: string) {}

  async getToken(action?: string) {
    return new Promise<string>((resolve, reject) => {
      if (!('grecaptcha' in window)) {
        reject(new Error('reCAPTCHA missing from page'));
        return;
      }

      const grecaptcha = (window as any).grecaptcha;
      const recaptcha = grecaptcha.enterprise ?? grecaptcha;

      recaptcha.ready(() => {
        recaptcha.execute(this.siteKey, { action }).then((token: string) => {
          resolve(token);
        });
      });
    });
  }
}

export default Recaptcha;
